import {
  Components,
  InputInformation,
  ValidationType,
  Size,
  RegexLib,
} from '@utahdts/dts-react-common';
import Inputmask from 'inputmask';
import { formatTextFieldValue } from '../../misc/textFieldFormatter';
import wireInputChanges from './wireInputChanges';

export default ({ inputsOnChange }, isNew, orgOptions = []) => {
  const inputs = {};

  // Administrators have no single selected org, so a new history must name its
  // company. Org Administrators file against their current org and never see
  // this control (orgOptions is empty for them).
  if (isNew && orgOptions.length > 0) {
    inputs.org = new InputInformation({
      field: 'org',
      label: 'Company:',
      type: Components.SELECT_INPUT,
      multiSelect: false,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      options: orgOptions,
    });
  }

  inputs.drugDescription = new InputInformation({
    field: 'drugDescription',
    label: 'Drug Name:',
    type: Components.TEXT_INPUT,
    validationTypes: ValidationType.REQUIRED,
    size: Size.FULL_WIDTH,
    disabled: !isNew,
  });

  inputs.patentLostDate = new InputInformation({
    field: 'patentLostDate',
    label: 'Patent Expiration Date:',
    type: Components.CALENDAR_INPUT,
    validationTypes: ValidationType.REQUIRED,
    size: Size.FULL_WIDTH,
    disabled: !isNew,
    maskType: {
      inputMask: new Inputmask('datetime', {
        inputFormat: 'mm/dd/yyyy',
        placeholder: 'MM/DD/YYYY',
        clearMaskOnLostFocus: false,
        onBeforePaste: (value) => {
          const formatted = formatTextFieldValue(value);
          formatted.supported &&
            formatted.value.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/) &&
            inputsOnChange('patentLostDate', formatted.value);
        },
      }),
      validation: {
        validationRegExp: RegexLib.DATE,
        validationErrorMessage: (data) => `${data} does not match MM/DD/YYYY`,
      },
      className: 'mask-date',
    },
  });

  wireInputChanges(inputs, inputsOnChange);

  return inputs;
};
